import Model from "./PaytModel.js";

export default {
  Section: {
    Modules: {
      Title: Model.ModuleType.List.Name + " " + Model.Module.FullName
    }
  }
}